import React, { createContext, useContext, useEffect } from 'react';
import io from 'socket.io-client';

const WebSocketContext = createContext(null);
export const useWebSocket = () => useContext(WebSocketContext);

export const WebSocketProvider = ({ children }) => {
    const socket = io('/', {
        withCredentials: true,
        transports: ['websocket', 'polling']
    });

    useEffect(() => {
        // Événements de connexion
        socket.on('connect', () => {
            console.log('🔌 Connecté au serveur WebSocket');
        });

        socket.on('connect_error', (error) => {
            console.error('Erreur de connexion WebSocket:', error);
        });

        socket.on('disconnect', () => {
            console.log('🔌 Déconnecté du serveur WebSocket');
        });

        // Événements spécifiques à vos services
        socket.on('serviceCreated', (data) => {
            console.log('📦 Nouveau service reçu:', data);
        });

        socket.on('serviceUpdated', (data) => {
            console.log('🔄 Service mis à jour reçu:', data);
        });

        // Nettoyage lors du démontage
        return () => {
            socket.off('connect');
            socket.off('connect_error');
            socket.off('disconnect');
            socket.off('serviceCreated');
            socket.off('serviceUpdated');
            socket.close();
        };
    }, [socket]);

    return (
        <WebSocketContext.Provider value={socket}>
            {children}
        </WebSocketContext.Provider>
    );
};